// /* eslint-disable  prefer-template, jsx-a11y/alt-text,  no-unneeded-ternary,react/destructuring-assignment */

import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Link } from 'react-router-dom';
import { format } from 'date-fns';

import styles from './View.Style';
import cornerPlus from '../../img/corner-plus.png';
import defaultImg from 'img/hero_image.png';
import chevronRight from 'img/chevron-right.png';

import { getChallengeStatus } from '../../services/GetStatusStyle';
import * as pages from '../../common_constants/Pages';
import NavigationService from 'support/navigation/NavigationService';

import ChallengeImage from './ChallengeImage';
import ExpiryInfo from './ExpiryInfo';
import RewardInfo from './RewardInfo';
import ProposerInfo from './ProposerInfo';


// export function getInitiativeFlag({ isHackathonChallenge = false, isInnovate = false }) {
//   if (isHackathonChallenge || isInnovate) return 'Hackathon';
//   // if (isInnovate) return 'innovate Africa';
//   return 'Nova';
// }

// Main Component: ChallengeCard
const ChallengeCard = (props) => {
    const {
      classes,
      challenge,
      taggedIcon,
      RadioCheckedValue,
      urlID,
      myChallenge,
      myChallengeHide,
      ideaDetailChallenge,
      enableIsHackathon,
      hideProposedName,
      innovateChallengeTagIdeaCount,
    } = props;
  
    // console.log("challenge--card",props,challenge)

    const {
      name,
      title,
      images,
      desc,
      descWithoutTags,
      proposerName,
      proposerEmail,
      ends,
      starts,
      status,
      numIdeas,
      rewardText,
      isInnovate,
      isHackathonChallenge = false,
      mainPhoto,
    } = challenge || {};
  
    const image = challenge?.image?.url || images?.[0]?.url || mainPhoto || defaultImg;
    const startingDate =  starts?.dateString || starts
    const endingDate =  ends?.dateString || ends
    const startDate = startingDate ? format(new Date(startingDate), 'dd MMM yy') : null;
    const EndDate = endingDate ? format(new Date(endingDate), 'dd MMM yy') : null;
    const { name: statusStr, color: statusCol } = getChallengeStatus(status);
  
    const trimmedName = title?.length > 50 ? `${title?.substring(0, 50)}...` : title;
    let trimmedDesc = descWithoutTags
    if (trimmedDesc?.length > 65) trimmedDesc = `${trimmedDesc?.substring(0,65)}...`
    // const trimmedDesc = descWithoutTags?.length > 65 ? `${descWithoutTags.substring(0, 65)}...` : descWithoutTags;
  
    const ROUTES = NavigationService.getRoutes();
    const detailChallengePath = ROUTES[pages.DETAIL_CHALLENGE].pathWithOutID;
  
  

// const isHackthonCheck = getInitiativeFlag({isHackathonChallenge,isInnovate})
    // console.log("🚀 ~ ChallengeCard ~ isHackThonCheck:", isHackThonCheck)




    return (
      <div className={classes.container}>
        {myChallenge && (
          <div className={classes.draftstatus} style={{ backgroundColor: statusCol }}>
            {statusStr}
          </div>
        )}
        {!RadioCheckedValue && taggedIcon && (
          <img className={classes.corner_img} src={cornerPlus} alt="tag icon" />
        )}
  
        <Link to={`${detailChallengePath}/${urlID}`}>
          <div
            className={`${RadioCheckedValue ? classes.activeRadioChallenge : ''} ${classes.box}`}
            style={{ borderTopLeftRadius: myChallenge ? '0px' : undefined,  border: `2px solid ${statusCol}`}}
          >
            <div className={classes.left_col}>
              <ChallengeImage src={image} classes={classes} />
                {/* <h4 className={classes.flags}>{isHackthonCheck}</h4>   */}
                <ExpiryInfo ends={EndDate} numIdeas={innovateChallengeTagIdeaCount || numIdeas} classes={classes} myChallengeHide={myChallengeHide} />
                {/* {enableIsHackathon ? (<ExpiryInfo ends={EndDate} numIdeas={innovateChallengeTagIdeaCount} classes={classes} myChallengeHide={myChallengeHide} />)
                :
                statusStr !== 'PROPOSED' && (
                  <ExpiryInfo ends={EndDate} numIdeas={numIdeas} classes={classes} myChallengeHide={myChallengeHide} />
                )} */}
            </div>
  
            <div className={classes.right_col}>
              <h3 className={classes.challenge_name}>{trimmedName}</h3>
  
              {/* {!myChallengeHide && (
                <ProposerInfo proposerName={proposerName} proposerEmail={proposerEmail} classes={classes} />
              )} */}
  
              {(myChallenge || ideaDetailChallenge) && (
                <RewardInfo rewardText={rewardText} classes={classes} />
              )}
  
              <div className={classes.challenge_desc}>{trimmedDesc}</div>
  
              <div className={classes.details}>
                {!taggedIcon && (
                  <>
                    View details
                    <img src={chevronRight} alt="rightarrow" className={classes.arrowright} />
                  </>
                )}
              </div>
              
            </div>
          </div>
        </Link>

      </div>
    );
  };
  

  export default withStyles(styles)(ChallengeCard)